"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSearchParameters = exports.getSearchOptions = void 0;
const types_1 = require("../types");
const calculateSizeWithLimit_1 = require("./calculateSizeWithLimit");
const getAlgoliaPageFilters_1 = require("./getAlgoliaPageFilters");
const getAlgoliaProductFilters_1 = require("./getAlgoliaProductFilters");
const getOffset_1 = require("./getOffset");
const location_1 = require("./location");
const getPaginationSearchParameters = (pagination) => {
    const page = pagination?.currentPage ? pagination?.currentPage - 1 : undefined;
    if (pagination?.limit) {
        const offset = (0, getOffset_1.getOffset)(pagination);
        const length = (0, calculateSizeWithLimit_1.calculateSizeWithLimit)({ ...pagination, offset });
        if (length) {
            return {
                offset,
                length,
                hitsPerPage: 0,
            };
        }
        return {
            page,
            hitsPerPage: 0,
        };
    }
    return {
        page,
        hitsPerPage: pagination?.size,
    };
};
const getFilter = (objectType, filter) => {
    switch (objectType) {
        case types_1.ObjectType.Product:
            return (0, getAlgoliaProductFilters_1.getAlgoliaProductFilters)(filter);
        case types_1.ObjectType.Page:
            return (0, getAlgoliaPageFilters_1.getAlgoliaPageFilters)(filter);
        default:
            return undefined;
    }
};
const getSearchOptions = (objectType, search, options) => {
    const productOptions = objectType === types_1.ObjectType.Product
        ? {
            aroundLatLng: (0, location_1.getLatLng)(search?.filter?.location),
            aroundRadius: (0, location_1.getRadius)(search?.sorting, search?.filter?.location?.distance),
            getRankingInfo: !!search?.filter?.location,
        }
        : {};
    const searchOptions = {
        ...getPaginationSearchParameters(search?.pagination),
        ...productOptions,
        userToken: options?.userToken,
        facets: options?.facetsToInclude,
        ruleContexts: options?.ruleContexts,
        clickAnalytics: !!options?.userToken,
        query: search?.searchTerm,
        filters: getFilter(objectType, search?.filter),
        attributesToRetrieve: options?.attributesToRetrieve,
        attributesToSnippet: options?.attributesToSnippet,
        attributesToHighlight: options?.attributesToHighlight,
        analyticsTags: options?.analyticsTags,
        highlightPreTag: options?.highlightPreTag,
        highlightPostTag: options?.highlightPostTag,
    };
    return Object.keys(searchOptions).reduce((acc, curr) => 
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    typeof searchOptions[curr] !== 'undefined'
        ? // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-expect-error
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            { ...acc, [curr]: searchOptions[curr] }
        : acc, {});
};
exports.getSearchOptions = getSearchOptions;
// getSearchParameters returns plain search parameters for usage with instantsearch on listing pages. Here we also set
// default facet query options. For direct usage with api clients, use getSearchOptions
const getSearchParameters = (objectType, search, 
// eslint-disable-next-line unicorn/no-object-as-default-parameter
options = {
    facetsToInclude: ['attributes.*'],
    disjunctiveFacets: ['dynamicAttributes'],
}) => {
    return {
        ...getSearchOptions(objectType, search, options),
        disjunctiveFacets: options?.disjunctiveFacets,
    };
};
exports.getSearchParameters = getSearchParameters;
//# sourceMappingURL=getSearchParameters.js.map